import { render, staticRenderFns } from "./GoogleFonts.vue?vue&type=template&id=96fd8572"
import script from "./GoogleFonts.vue?vue&type=script&lang=js"
export * from "./GoogleFonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports